export const intlViVn = {
    测试: 'Bài kiểm tra',
    登录: 'Đăng nhập',
    注册: 'Đăng ký',
    变量的例子: 'Ví dụ về biến {value}',
    多样式多语言例子: '<span style="font-size: 12px;color: #d7cab3;">Ví dụ về biến <span style="font-size: 16px;color: #fff;font-weight: 600;">@money</span></span>',
    体育: 'Thể thao',
    存款: 'Tiền gửi',
    提款: 'Rút tiền',
    请登录: 'Vui lòng đăng nhập',
    余额刷新成功: 'Cập nhật số dư thành công',
    我的金额: 'Số tiền của tôi',
    我的邀请码: 'Mã mời của tôi',
    复制成功: 'Sao chép thành công',
    下一次抽奖: 'Lần quay tiếp theo',
    您没有抽奖的机会: 'Bạn không có cơ hội quay số',
    规则: 'Quy tắc',
    我的: 'Của tôi',
    我的信息: 'Thông tin của tôi',
    资金详情: 'Chi tiết tiền',
    在线客服: 'Hỗ trợ trực tuyến',
    客服暂未配置: 'Hỗ trợ chưa được cấu hình',
    促销码: 'Mã khuyến mãi',
    请输入促销码: 'Vui lòng nhập mã khuyến mãi',
    验证码: 'Mã xác minh',
    请输入验证码: 'Vui lòng nhập mã xác minh',
    提交: 'Gửi',
    退出登录: 'Đăng xuất',
    提示: 'Gợi ý',
    '确定要退出登录吗？': 'Bạn có chắc muốn đăng xuất không?',
    取消: 'Hủy',
    确定: 'Xác nhận',
    '升级到 {value} 还需要 {value}': 'Nâng cấp lên {value1} cần thêm {value2}',
    头像: 'Ảnh đại diện',
    用户名: 'Tên người dùng',
    登录密码: 'Mật khẩu đăng nhập',
    提现密码: 'Mật khẩu rút tiền',
    修改提现密码: 'Thay đổi mật khẩu rút tiền',
    修改密码: 'Thay đổi mật khẩu',
    设置提现密码: 'Thiết lập mật khẩu rút tiền',
    请输入提现密码: 'Vui lòng nhập mật khẩu rút tiền',
    请再次输入提现密码: 'Vui lòng nhập lại mật khẩu rút tiền',
    提现密码不能为空: 'Mật khẩu rút tiền không được để trống',
    确认提现密码不能为空: 'Xác nhận mật khẩu rút tiền không được để trống',
    提现密码格式不正确: 'Mật khẩu rút tiền không đúng định dạng',
    确认提现密码格式不正确: 'Xác nhận mật khẩu rút tiền không đúng định dạng',
    提现密码和确认提现密码不一致: 'Mật khẩu rút tiền và xác nhận mật khẩu rút tiền không giống nhau',
    设置提现密码成功: 'Thiết lập mật khẩu rút tiền thành công',
    请输入旧密码: 'Vui lòng nhập mật khẩu cũ',
    请输入新密码: 'Vui lòng nhập mật khẩu mới',
    请再次输入新密码: 'Vui lòng nhập lại mật khẩu mới',
    旧密码不能为空: 'Mật khẩu cũ không được để trống',
    新密码不能为空: 'Mật khẩu mới không được để trống',
    确认密码不能为空: 'Xác nhận mật khẩu không được để trống',
    '旧密码格式不正确, 请输入6-18位字母或数字': 'Mật khẩu cũ không đúng định dạng, vui lòng nhập 6-18 ký tự chữ hoặc số',
    '新密码格式不正确, 请输入6-18位字母或数字': 'Mật khẩu mới không đúng định dạng, vui lòng nhập 6-18 ký tự chữ hoặc số',
    '确认密码格式不正确, 请输入6-18位字母或数字': 'Xác nhận mật khẩu không đúng định dạng, vui lòng nhập 6-18 ký tự chữ hoặc số',
    新密码和确认密码不一致: 'Mật khẩu mới và xác nhận mật khẩu không giống nhau',
    '修改密码成功, 请重新登录': 'Thay đổi mật khẩu thành công, vui lòng đăng nhập lại',
    修改提现密码成功: 'Thay đổi mật khẩu rút tiền thành công',
    选择头像: 'Chọn ảnh đại diện',
    今天: 'Hôm nay',
    昨天: 'Hôm qua',
    一个月内: 'Trong vòng một tháng',
    余额: 'Số dư',
    编号: 'Số thứ tự',
    备注: 'Ghi chú',
    提现金额: 'Số tiền rút',
    充值: 'Nạp tiền',
    账变: 'Thay đổi tài khoản',
    所有类型: 'Tất cả các loại',
    每天: 'Mỗi ngày',
    每周: 'Mỗi tuần',
    每月: 'Mỗi tháng',
    活动名称: 'Tên sự kiện',
    优惠金额: 'Số tiền ưu đãi',
    申请时间: 'Thời gian đăng ký',
    '发放/审核时间': 'Thời gian phát hành/duyệt',
    状态: 'Trạng thái',
    活动奖项: 'Giải thưởng sự kiện',
    排名: 'Xếp hạng',
    每日列表: 'Danh sách hàng ngày',
    每周列表: 'Danh sách hàng tuần',
    每月列表: 'Danh sách hàng tháng',
    没有排名: 'Không có xếp hạng',
    我的投注: 'Cược của tôi',
    我的奖励: 'Phần thưởng của tôi',
    剩余排名: 'Xếp hạng còn lại',
    空缺: 'Trống',
    奖励: 'Phần thưởng',
    总投注: 'Tổng cược',
    投注: 'Cược',
    '占所有玩家总投注额的 {value} %': 'Chiếm {value} % tổng số tiền cược của tất cả người chơi',
    暂无数据: 'Không có dữ liệu',
    首页: 'Trang chủ',
    优惠活动: 'Ưu đãi',
    推广: 'Quảng cáo',
    请选择: 'Vui lòng chọn',
    年: 'Năm',
    月: 'Tháng',
    日: 'Ngày',
    上午: 'Sáng',
    下午: 'Chiều',
    天: 'Ngày',
    周: 'Tuần',
    投注返利详情:
        '<span style="font-size: 10px;color: #d7cab3;">Tổng số tiền cược của đội bạn là {value1}, và bạn có thể nhận được tới <span style="font-size: 14px;color: #fff;font-weight: 600;">{value2}</span> mỗi tháng.</span>',
    优惠活动详情: 'Chi tiết khuyến mãi',
    活动申请: 'Ứng dụng hoạt động',
    加载中: 'Đang tải',
    申请: 'Áp dụng',
    申请成功: 'Ứng dụng thành công',
    申请失败: 'Ứng dụng không thành công',
    所有记录: 'Tất cả hồ sơ',
    申请中: 'Áp dụng',
    发放成功: 'Phát hành thành công',
    审核失败: 'Xem xét không thành công',
    活动申请记录: 'Hồ sơ đăng ký hoạt động',
    原因: 'Lý do',
    邮件: 'Thư',
    邮件最多可保存30天: 'Thư có thể được lưu trong tối đa 30 ngày',
    删除已读: 'Xóa Đọc',
    全部接收: 'Nhận tất cả',
    邮件详情: 'Chi tiết thư',
    删除: 'Xóa',
    确认密码: 'Xác nhận mật khẩu',
    真实姓名: 'Tên thật',
    姓: 'Họ',
    名: 'Tên',
    邮箱: 'Email',
    邮箱验证码: 'xác minh Email',
    发送: ' Gửi',
    手机号: 'Số điện thoại di động',
    手机验证码: 'Mã xác minh trên thiết bị di động',
    出生日期: 'Ngày sinh',
    twitter: 'twitter',
    facebook: 'facebook',
    证件类型: 'loại ID',
    证件号: 'số ID',
    推广码: 'Mã khuyến mãi',
    优惠码: 'mã đổi thưởng',
    登录成功: 'Đăng nhập thành công',
    登录失败: 'Đăng nhập không thành công',
    登录账号: 'Tài khoản đăng nhập',
    请输入正确的邮箱: 'Vui lòng nhập địa chỉ email hợp lệ',
    请选择手机区号: 'Vui lòng chọn mã vùng di động',
    手机号校验: 'Vui lòng nhập một Số điện thoại di động 6-12 chữ số',
    请输入10位手机号: 'Vui lòng nhập một Số điện thoại di động 10 chữ số',
    验证码发送成功: 'Mã xác minh được gửi thành công',
    用户名验证: 'Tên người dùng phải bắt đầu bằng (6-15) chữ cái và kết hợp chữ thường và số',
    用户名不能以test为起始: 'Tên người dùng không thể bắt đầu bằng kiểm tra',
    密码必须为6位数字: 'Mật khẩu phải có 6 chữ số',
    确认密码必须为6位数字: 'Xác nhận mật khẩu phải có 6 chữ số',
    两次输入的密码不一致: 'Nhập hai lần Mật khẩu không khớp.',
    登录密码验证: 'Mật khẩu phải là sự kết hợp của (6 đến 18 ký tự) chữ cái, số hoặc ký tự đặc biệt',
    确认登录密码验证: 'Xác nhận rằng mật khẩu phải là sự kết hợp của (6 đến 18 ký tự) chữ cái, số hoặc ký tự đặc biệt',
    请输入正确的姓名: 'Vui lòng nhập tên chính xác của bạn',
    请输入出生日期: 'Vui lòng nhập ngày sinh của bạn',
    请输入您的twitter账号: 'Vui lòng nhập tài khoản {value} của bạn',
    请输入您的facebook账号: 'Vui lòng nhập tài khoản Facebook của bạn',
    推广码校验: 'Xác nhận rằng bạn đã nhập đúng mã khuyến mại (1 đến 8 chữ số)',
    推广码校验2: 'Vui lòng nhập mã khuyến mại',
    请点击开始验证: 'Vui lòng nhấp vào Bắt đầu xác minh',
    请输入邮箱验证码: 'Vui lòng nhập mã xác minh email',
    请输入手机验证码: 'Vui lòng nhập mã xác minh trên thiết bị di động',
    请输入姓: 'Vui lòng nhập họ của bạn',
    请输入名: 'Vui lòng nhập tên của bạn',
    请输入证件号: 'Vui lòng nhập số ID của bạn',
    请输入有效的CURP: 'Vui lòng nhập CURP hợp lệ',
    '请输入11~14位数字': 'Vui lòng nhập 11 đến 14 chữ số',
    请选择证件类型: 'Vui lòng chọn loại ID',
    请接受服务条款: 'Vui lòng chấp nhận các điều khoản dịch vụ',
    邀请奖励: 'Phần thưởng mời',
    问题1: 'Q1: Chia hoa hồng có nghĩa là gì?',
    回答1: 'A1: Sau khi mời bạn bè tham gia ứng dụng và liên kết mã mời của bạn, bạn sẽ nhận được hoa hồng bổ sung dựa trên mức tiêu thụ của những người bạn này theo một tỷ lệ nhất định. ',
    问题2: 'Q2: Câu lạc bộ nghĩa là gì?',
    回答2: 'A2: Câu lạc bộ của bạn bao gồm tất cả các thành viên trong nhóm đại lý của bạn.',
    问题3: 'Q3: Làm cách nào tôi có thể nâng cấp lên xếp hạng sao câu lạc bộ cao hơn?',
    回答3: 'A3: Bạn có thể nâng cấp bằng cách mời thêm bạn bè hoặc tiêu dùng chung với các thành viên trong nhóm. Để biết thêm thông tin chi tiết, vui lòng tham khảo bảng yêu cầu nâng cấp.',
    问题4: 'Q4: Làm cách nào để tôi nhận được phần thưởng?',
    回答4: 'A4: Sau khi bạn bè hoặc lời mời của bạn bè bạn thực hiện mua hàng, bạn sẽ ngay lập tức nhận được tất cả phần thưởng, số tiền này sẽ được gửi vào tài khoản hoa hồng của bạn và có thể được rút về ví của bạn vào ngày hôm sau.',
    问题5: 'Q5: Có bất kỳ yêu cầu đặt cược nào để rút phần thưởng không?',
    回答5: 'A5: Có yêu cầu đặt cược một lần.',
    问题6: 'Q6: Khi nào tôi có thể sử dụng phần thưởng của mình?',
    回答6: 'A6: Bạn có thể rút phần thưởng về tài khoản của mình ví để chi tiêu vào ngày hôm sau. Đôi khi có thể có một chút chậm trễ. Cảm ơn bạn đã thông cảm.',
    佣金比例详情:
        '※Bạn có thể nhận được một tỷ lệ phần trăm hoa hồng nhất định từ tất cả các cược và số tiền nạp lại do A, B và C thực hiện. Vui lòng tham khảo sơ đồ sau để biết tỷ lệ hoa hồng cụ thể.',
    返利比例详情: '※Các trò chơi khác nhau có mức hoàn tiền khác nhau tỷ lệ. Bạn cũng có thể tăng tỷ lệ hoàn tiền bằng cách nâng cấp xếp hạng sao cho câu lạc bộ của mình.',
    立即邀请: 'Mời ngay!',
    佣金率: 'Tỷ lệ hoa hồng',
    流水返利: 'Hoàn tiền trên doanh thu',
    俱乐部之星: 'Sao câu lạc bộ',
    佣金等级: 'Hoa hồng cấp {value}',
    首存返利: 'Hoàn tiền khi gửi tiền lần đầu',
    什么是俱乐部: 'Câu lạc bộ là gì?',
    俱乐部的星级越高介绍: 'Bạn và tất cả người đại diện của bạn thành lập câu lạc bộ của mình. Xếp hạng sao của câu lạc bộ càng cao, tỷ lệ hoàn tiền càng cao.',
    你的俱乐部: 'Câu lạc bộ của bạn',
    如何提高俱乐部的星级: 'Làm thế nào để tăng xếp hạng sao của câu lạc bộ?',
    代理要求: 'Yêu cầu của đại lý',
    投注要求: 'Yêu cầu đặt cược',
    无星: 'Không có sao',
    一星: 'Một sao',
    二星: 'Hai sao',
    三星: 'Ba sao',
    全部: 'Tất cả',
    我的奖金: 'Tiền thưởng của tôi',
    下一级: 'Cấp tiếp theo',
    累计存款: 'Tích lũy tiền gửi {value}',
    每日提款限额: 'Giới hạn rút tiền hàng ngày',
    每日提现次数: 'Số lần rút tiền mỗi ngày',
    每月累计存款升级VIP等级: 'Gửi tiền tích lũy hàng tháng Nâng cấp cấp VIP',
    等级: 'Cấp độ',
    月度奖金: 'Tiền thưởng hàng tháng',
    等级升级奖励: 'Tiền thưởng nâng cấp cấp độ',
    现金奖励发放时间: 'Tiền thưởng : Dựa trên của bạn Cấp VIP vào cuối tháng này, phần thưởng này sẽ được gửi đến bạn vào lúc 10 giờ sáng. vào đầu tháng tiếp theo.',
    晋级彩金: 'Tiền thưởng nâng cấp',
    每月奖金: 'Tiền thưởng hàng tháng',
    投注返水: 'Hoàn tiền đặt cược',
    网络问题: 'Vấn đề mạng',
    '检测到您目前没有网络连接，请开启网络后再试。': 'Phát hiện ra rằng bạn hiện không có kết nối mạng, vui lòng mở mạng và thử lại.',
    设置: 'Cài đặt',
    总奖励: 'Tổng phần thưởng',
    邀请总数: 'Tổng số lời mời',
    邀请有效用户数量: 'Bạn đã mời tổng cộng {value1} bạn bè, trong đó {value2} là người dùng hợp lệ.',
    邀请新客户获得: 'Mời khách hàng mới nhận',
    邀请好友可获得: 'Bạn bè được mời nhận',
    邀请好友获取金钱: 'Mời bạn bè nhận tiền',
    每日邀请次数: 'Thời gian mời hàng ngày: {value}',
    邀请300位好友可获得: 'Mời {value} bạn bè nhận được',
    如何参与: 'CÁCH THAM GIA',
    步骤1: 'Bước 1: Đăng ký',
    步骤2: 'Bước 2: Nhấp vào bất kỳ trang mời nào để mời bạn bè',
    步骤3: 'Bước 3: Bạn bè đăng ký và nhập mã mời',
    步骤4: 'Bước 4: Bạn bè gửi tiền {value}',
    步骤5: 'Bước 5: Nhận phần thưởng',
    什么是有效邀请用户: 'NGƯỜI DÙNG HỢP LỆ LÀ GÌ?',
    有效邀请用户描述: 'Người dùng được mời hợp lệ là người có đã gửi số tiền tích lũy lớn hơn {value}',
    奖励兑换: 'THƯỞNG THƯỞNG',
    奖励兑换步骤1: 'Đối với mỗi lời mời thành công, người mời sẽ nhận được {value1}.',
    奖励兑换步骤2: 'Đại lý trực tiếp (cấp trên của người mời) nhận được tiền thưởng {value}.',
    奖励兑换步骤3: 'Đại lý cấp trên của đại lý trực tiếp nhận được tiền thưởng {value}.',
    奖励兑换步骤4: 'Người dùng được mời cũng nhận được tiền thưởng {value}.',
    奖励兑换步骤5: 'Phần thưởng có thể được sử dụng để chơi trò chơi.',
    奖励兑换步骤6: 'Phần thưởng được hệ thống tự động phân phối.',
    活动解释权: '{value} giữ quyền giải thích cuối cùng cho hoạt động này.',
    '安装权限未被授予，无法打开APK文件': 'Không cấp quyền cài đặt, không thể mở tệp APK',
    '权限已授予，正在尝试打开APK...': 'Quyền đã được cấp, đang cố gắng mở tệp APK...',
    立即更新: 'Cập nhật ngay',
    稍后更新: 'Cập nhật sau',
    版本号不符合规范: 'Số phiên bản không đúng quy định',
    邀请人数: 'Số lượng lời mời',
    奖励详情: 'Chi tiết phần thưởng',
    '网络错误, 请稍后重试!': 'Lỗi mạng, vui lòng thử lại sau!',
    存款金额: 'Số tiền gửi',
    奖励金额: 'Số tiền thưởng',
    立即存款: 'Gửi tiền ngay',
    今天不再显示: 'Không hiển thị lại hôm nay',
    倒计时: 'đếm ngược',
    应用未安装: 'Ứng dụng chưa được cài đặt',
    邀请码: 'Mã mời',
    请输入用户名: 'Vui lòng nhập tên người dùng',
    密码: 'Mật khẩu',
    请输入密码: 'Vui lòng nhập mật khẩu',
    '密码必须为(6~18位)字母或数字组合': 'Mật khẩu phải là sự kết hợp của (6-18 ký tự) chữ cái hoặc số',
    忘记密码: 'Quên mật khẩu',
    注册账号: 'Đăng ký tài khoản',
    重置密码: 'Đặt lại mật khẩu',
    '确定进入游戏吗?': 'Bạn có chắc chắn muốn chơi không?',
    '确定要支付吗?': 'Bạn có chắc chắn muốn thanh toán không?',
    进入游戏失败: 'Không vào được game',
    充值请求已取消: 'Yêu cầu nạp tiền đã bị hủy',
    已提交充值请求: 'Yêu cầu nạp tiền đã được gửi',
    存款方式: 'Phương thức gửi tiền',
    存款账户: 'Tài khoản gửi tiền',
    收款户名: 'Tên người nhận tiền: ',
    银行账户: 'Tài khoản ngân hàng: ',
    开户地址: 'Địa chỉ mở tài khoản: ',
    开户银行: 'Ngân hàng mở tài khoản: ',
    单笔范围: 'Phạm vi một lần gửi: ',
    存款优惠: 'Ưu đãi gửi tiền',
    最高奖金: 'Tiền thưởng tối đa: ',
    剩余数量: 'Số lượng còn lại: ',
    不选择: 'Không chọn',
    请选择优惠: 'Vui lòng chọn ưu đãi',
    充值优惠详情: 'Chi tiết ưu đãi nạp tiền',
    详情: 'Chi tiết',
    最小额: 'Nhỏ',
    最大额: 'Lớn',
    存款提示: 'Lời nhắc gửi tiền',
    存款提示1: 'Mỗi lần gửi tiền sẽ được xử lý trong vòng 1-5 phút',
    存款提示2: 'Bạn có thể liên hệ với bộ phận hỗ trợ khách hàng bất cứ lúc nào để giải quyết vấn đề tiền gửi',
    充值金额不能小于最小金额: 'Số tiền nạp không được nhỏ hơn số tiền nhỏ nhất',
    立即支付: 'Thanh toán ngay',
    下一步: 'Bước tiếp theo',
    USDT数量: 'Số lượng USDT',
    充值金额: 'Số tiền nạp',
    复制: 'Sao chép',
    TXID后五位: 'Năm chữ số cuối của TXID',
    汇款信息: 'Thông tin chuyển khoản',
    '(必填)请输入汇款人姓名或者卡号后四位': '(Bắt buộc) Vui lòng nhập tên người chuyển khoản hoặc bốn chữ số cuối của số thẻ',
    上一步: 'Bước trước',
    备注信息不允许为空: 'Thông tin ghi chú không được để trống',
    收款银行: 'Ngân hàng nhận tiền ',
    银行地址: 'Địa chỉ ngân hàng ',
    PIX类型: 'Loại PIX ',
    账号名称: 'Tên tài khoản',
    收款账户: 'Tài khoản nhận tiền ',
    PIX账号: 'Tài khoản PIX',
    选择钱包类型: 'Chọn loại ví',
    '获取钱包列表失败, 请联系客服': 'Không lấy được danh sách ví, vui lòng liên hệ với bộ phận hỗ trợ khách hàng',
    请选择钱包类型: 'Vui lòng chọn loại ví',
    收款地址: 'Địa chỉ nhận tiền ',
    当前汇率: 'Tỷ giá hiện tại',
    转换金额: 'Số tiền chuyển đổi ',
    单日提现金额上限: 'Giới hạn số tiền rút trong ngày: ',
    单日提现次数上限: 'Giới hạn số lần rút trong ngày: ',
    单笔最低提现额度: 'Số tiền rút tối thiểu một lần: ',
    单笔最高提现额度: 'Số tiền rút tối đa một lần: ',
    提现时间段: 'Khoảng thời gian rút tiền: ',
    普通余额: 'Số dư thông thường: ',
    代理余额: 'Số dư đại lý: ',
    普通余额可兑换USDT数量: 'Số lượng USDT có thể đổi từ số dư thông thường: ',
    代理余额可兑换USDT数量: 'Số lượng USDT có thể đổi từ số dư đại lý: ',
    '你还没绑定三方钱包哦!': 'Bạn chưa liên kết ví bên thứ ba!',
    选择钱包: 'Chọn ví',
    请输入提现金额: 'Vui lòng nhập số tiền rút',
    请输入有效金额: 'Vui lòng nhập số tiền hợp lệ',
    请输入正整数金额: 'Vui lòng nhập số tiền là số nguyên dương',
    普通余额不足: 'Số dư thông thường không đủ',
    代理余额不足: 'Số dư đại lý không đủ',
    请选择三方钱包: 'Vui lòng chọn ví bên thứ ba',
    '你还没虚拟货币地址哦!': 'Bạn chưa có địa chỉ tiền điện tử!',
    请输入要兑换的USDT数量: 'Vui lòng nhập số lượng USDT cần đổi',
    请输入有效枚数: 'Vui lòng nhập số lượng hợp lệ',
    请输入正整数枚数: 'Vui lòng nhập số lượng là số nguyên dương',
    提款数量不能大于可提款USDT数量: 'Số lượng rút không được lớn hơn số lượng USDT có thể rút',
    请输入提款金额: 'Vui lòng nhập số tiền rút',
    请选择钱包: 'Vui lòng chọn ví',
    '你还没绑定银行卡哦!': 'Bạn chưa liên kết thẻ ngân hàng!',
    选择银行卡: 'Chọn thẻ ngân hàng',
    请选择银行卡: 'Vui lòng chọn thẻ ngân hàng',
    '你还没绑定PIX哦!': 'Bạn chưa liên kết PIX!',
    选择PIX: 'Chọn PIX',
    请选择PIX类型: 'Vui lòng chọn loại PIX',
    '你还没绑定支付宝哦!': 'Bạn chưa liên kết Alipay!',
    选择支付宝: 'Chọn Alipay',
    请选择支付宝: 'Vui lòng chọn Alipay',
    去绑定: 'Đi liên kết',
    已选: 'Đã chọn',
    兑换全部: 'Đổi tất cả',
    当前提款不在时间段内: 'Hiện tại không trong khoảng thời gian rút tiền',
    钱包中心: 'Trung tâm ví',
    绑卡提示: 'Kính gửi quý khách, để bảo vệ thông tin của bạn, mặc định chỉ có thể liên kết {value} thẻ, nếu cần loại bỏ hoặc thay đổi, vui lòng liên hệ với bộ phận hỗ trợ khách hàng',
    钱包地址: 'Địa chỉ ví',
    请输入钱包地址: 'Vui lòng nhập địa chỉ ví',
    请输入字母或数字: 'Vui lòng nhập chữ cái hoặc số',
    钱包姓名: 'Tên ví',
    请输入钱包姓名: 'Vui lòng nhập tên ví',
    持卡人姓名: 'Tên chủ thẻ',
    钱包名称: 'Tên ví',
    钱包账号: 'Tài khoản ví',
    开户行地址: 'Địa chỉ ngân hàng mở tài khoản',
    钱包类型: 'Loại ví',
    "TRC20需以字母'T'开头的34位字符": "TRC20 phải bắt đầu bằng chữ 'T' và có 34 ký tự",
    银行卡类型: 'Loại thẻ ngân hàng',
    请选择银行卡类型: 'Vui lòng chọn loại thẻ ngân hàng',
    请输入开户行地址: 'Vui lòng nhập địa chỉ ngân hàng mở tài khoản',
    已有银行卡号: 'Số thẻ ngân hàng hiện có',
    请输入已有银行卡号: 'Vui lòng nhập số thẻ ngân hàng hiện có',
    银行卡账号: 'Tài khoản thẻ ngân hàng',
    请输入银行卡账号: 'Vui lòng nhập tài khoản thẻ ngân hàng',
    请输入持卡人姓名: 'Vui lòng nhập tên chủ thẻ',
    银行名称: 'Tên ngân hàng',
    银行账号: 'Tài khoản ngân hàng',
    支付宝姓名: 'Tên Alipay',
    请输入支付宝姓名: 'Vui lòng nhập tên Alipay',
    支付宝账号: 'Tài khoản Alipay',
    请输入支付宝账号: 'Vui lòng nhập tài khoản Alipay',
    添加新账户: 'Thêm tài khoản mới',
    资料信息提交成功: 'Thông tin đã được gửi thành công',
    联系地址: 'Địa chỉ liên hệ',
    请输入联系地址: 'Vui lòng nhập địa chỉ liên hệ',
    完善信息: 'Hãy bắt đầu',
    请先完善个人信息: 'Vui lý bắt đầu thư viện',
    请先选择优惠: 'Vui lý chọn ưu đã',
    请输入PIX账号: 'Vui lý nhap ten tai khoan PIX',
    活动金额: 'Số tiền hoạt động',
    更换成功: 'Thay thế thành công',
    注册成功: 'đăng ký thành công',
    注册失败: 'đăng ký thất bại',
    请选择线路: 'Vui lòng chọn đường dẫn',
    '线路{value}': 'Đường dẫn {value}',
    存款前请先绑定银行卡: 'Số tiền trên này, vui lý bắt đầu thư viện',
    额度回收: 'Hãy bắt đầu',
    一键刷新: 'Làm mới với một cú nhấp chuột',
    一键回收: 'Thu hồi với một cú nhấp chuột',
    主平台金额: 'Số tiền nền tảng chính',
    我的团队俱乐部: 'Câu lạc bộ đồng đội của tôi',
    俱乐部星级: 'Xếp hạng sao câu lạc bộ',
    俱乐部星级提示: 'Sao câu lạc bộ càng cao, tỷ lệ hoàn tiền càng cao',
    俱乐部成员: 'Thành viên câu lạc bộ',
    俱乐部投注: 'Cược câu lạc bộ',
    我的返佣: 'Hoàn tiền của tôi:',
    投注返佣高达: 'Hoàn tiền cược lên đến',
    首次存款返佣: 'Hoàn tiền gửi tiền lần đầu',
    可领取: 'Có thể nhận',
    领取: 'Nhận',
    领取成功: 'Nhận thành công',
    领取失败: 'Nhận thất bại',
    今日奖励: 'Phần thưởng hôm nay',
    邀请朋友: 'Mời bạn bè',
    通过WhatsApp邀请: 'Mời qua WhatsApp',
    保存图片: 'Lưu ảnh',
    分享: 'Chia sẻ',
    从属数据: 'Dữ liệu phụ thuộc',
    总人数: 'Tổng số người',
    本月: 'Tháng này',
    层级: 'Cấp độ',
    加入时间: 'Thời gian tham gia',
    佣金: 'Hoa hồng',
    提款历史记录: 'Lịch sử rút tiền',
    邀请: 'Mời',
    邀请任务: 'Nhiệm vụ mời',
    时间: 'Thời gian',
    佣金金额: 'Số tiền hoa hồng',
    成功: 'Thành công',
    下级: 'Cấp dưới',
    受邀人数: 'Số người được mời',
    佣金总额: 'Tổng số tiền hoa hồng',
    提现公告: '{value1} đã rút thành công {value2}',
    个人资料: 'Hồ sơ',
    用户信息: 'Thông tin người dùng',
    昵称: 'Tên người dùng',
    今天1: 'Hôm nay',
    昨天1: 'Hôm qua',
    奖励详情1: 'Chi tiết phần thưởng',
    投注1: 'Cược',
    存款1: 'Tiền gửi',
    状态1: 'Trạng thái',
    邀请奖励高达: 'Phần thưởng mời lên đến',
    平台名称: 'Tên nền tảng',
    金额: 'Số tiền',
    刷新: 'Làm lại',
    回收: 'Thu hö',
    休眠提示: 'Nhấp quá thường xuyên, vui lòng thử lại sau {value} giây',
    刷新成功: 'Làm lại thanh cong',
    刷新失败: 'Làm lại thể bắi',
    回收成功: 'Thu này thanh cong',
    回收失败: 'Thu được thể bắi',
    存款提示3: '1. Mỗi khoản tiền gửi sẽ được ghi có trong vòng 1-5 phút.',
    存款提示4: '2.Bạn có thể liên hệ với bộ phận chăm sóc khách hàng bất kỳ lúc nào để giải quyết các vấn đề về tiền gửi.',
    提款提示: 'Mẹo rút tiền',
    提款提示1: 'Trong trường hợp bình thường, số tiền rút sẽ đến tài khoản của bạn trong khoảng 2 giờ và thời gian dài nhất sẽ không quá 24 giờ',
    钱包: 'Ví',
    我的余额: 'Số dư của tôi',
    绑定手机号: 'Liên kết số điện thoại',
    绑定成功: 'Liên kết thành công',
    未绑定: 'Bỏ liên kết',
    验证码发送失败: 'Gửi mã xác minh không thành công',
    投注记录: 'Hồ sơ cược',
    投注金额: 'Số tiền cược',
    投注时间: 'Thời gian cược',
    订单号: 'Số đơn hàng',
    平台: 'Nền tảng',
    游戏名: 'Tên trò chơi',
    玩法: 'Cách chơi',
    投注模式: 'Chế độ cược',
    有效投注: 'Cược hợp lệ',
    盈亏金额: 'Số tiền lời/lỗ',
    '1、功能优化、性能优化': '1. Tối ưu hóa chức năng và hiệu suất',
    '2、修复一些已知问题': '2. Sửa một số vấn đề đã biết',
    发现新版本: 'Phát hiện phiên bản mới',
    奖励2: 'Phần thưởng',
    下一次免费旋转: 'Vòng quay miễn phí tiếp theo',
    请输入正确的IFSC码: 'Vui lòng nhập mã IFSC chính xác',
    记录: 'Ghi lại',
    提款剩余时间: 'Thời gian rút tiền còn lại ',
    收集提现: 'Để rút tiền khi bạn thu thập được {value}',
    剩余提现额: '<span style="font-size: 13px;color: #ffffff;">chỉ cần <span style="font-size: 13px;color: #e9b742;">{value}</span> để thực hiện</span>',
    邀请好友获得免费旋转: 'Mời bạn bè để nhận Vòng quay miễn phí',
    选择您的奖励: 'Chọn phần thưởng của bạn',
    每日免费提款: 'Rút tiền miễn phí hằng ngày',
    所有时间: 'Tất cả thời gian',
    本周: 'Tuần này',
    上周: 'Tuần trước',
    QQ: 'QQ',
    微信: 'WeChat',
    telegram: 'telegram',
    whatsApp: 'whatsApp',
    line: 'line',
    instagram: 'Instagram',
    手机号格式不正确: 'Định dạng số điện thoại không chính xác',
    请输入真实姓名: 'Vui lòng nhập tên thật',
    不限制: 'không có giới hạn',
    请输入订单号: 'Vui lòng nhập mã đơn hàng',
    立即游戏: 'Chơi ngay',
    '存款 {value} 即可获得 {value} 次旋转。': 'Gửi {value1} để nhận {value2} lần quay.',
    '1次': '{value} lần',
    历史: 'Lịch sử',
    活动规则: 'Quy tắc hoạt động',
    游戏维护中: 'Trò chơi đang được bảo trì',
    游戏维护时间: 'Trò chơi đang được bảo trì,Thời gian bảo trì: {value}',
    快捷登录: 'Đăng nhập nhanh',
    绑定Google账号: 'Liên kết tài khoản Google',
    绑定失败: 'Liên kết thất bại',
    支持: 'Hỗ trợ',
    更多: 'Thêm',
    提现次数: '{value} lần',
    '请安装Google Play服务': 'Vui lòng cài đặt dịch vụ Google Play',
    '暂无相册权限，请前往设置开启权限': 'Không có quyền truy cập vào album, vui lòng mở quyền truy cập trong cài đặt',
    '暂无相机权限，请前往设置开启权限': 'Không có quyền truy cập vào máy ảnh, vui lòng mở quyền truy cập trong cài đặt',
    '暂无麦克风权限，请前往设置开启权限': 'Không có quyền truy cập vào microphone, vui lòng mở quyền truy cập trong cài đặt',
    '暂无手机存储权限，请前往设置开启权限': 'Không có quyền truy cập vào bộ nhớ điện thoại, vui lòng mở quyền truy cập trong cài đặt',
    请输入IFSC码: 'Vui lòng nhập mã IFSC',
    搜索: 'tìm kiếm',
    恭喜你: 'Chúc mừng bạn',
    用户名或手机号码: 'tên người dùng hoặc số điện thoại di động',
    请输入用户名或手机号码: 'Vui lòng nhập tên người dùng hoặc số điện thoại di động của bạn',
    玩法说明: 'Hướng dẫn cách chơi',
    截止时间: 'Thời gian kết thúc',
    随机投注: 'Cược ngẫu nhiên',
    游戏记录: 'Lịch sử trò chơi',
    图表趋势: 'Biểu đồ xu hướng',
    我的投注记录: 'Lịch sử cược của tôi',
    期号: 'Số kỳ',
    '大/小': 'Lớn/Nhỏ',
    数字: 'Số',
    颜色: 'Màu',
    大: 'Lớn',
    小: 'Nhỏ',
    '投注助手（过去100期）': 'Trợ lý cược (100 kỳ trước)',
    开奖号码: 'Số trúng thưởng',
    数量: 'Số lượng',
    我同意: 'Tôi đồng ý',
    预售规则详情:
        'Để bảo vệ quyền và lợi ích hợp pháp của người dùng tham gia bán trước và duy trì trật tự hoạt động bình thường, các quy tắc được thực hiện theo các thỏa thuận và quy định có liên quan. 1.1 Định nghĩa bán trước: đề cập đến mô hình bán hàng trong đó người bán cung cấp giải pháp sản phẩm hoặc dịch vụ, thu thập đơn đặt hàng của người tiêu dùng thông qua các công cụ bán trước sản phẩm và cung cấp cho người tiêu dùng hàng hóa hoặc dịch vụ theo thỏa thuận trước. 1.2 Mô hình bán trước khi bán là mô hình "đặt cọc". "Tiền đặt cọc" là số tiền cố định trong giá bán trước của hàng hóa được giao trước. "Gửi tiền" có thể tham gia các trò chơi nhỏ và có cơ hội giành được nhiều tiền gửi hơn. Tiền gửi có thể được trao đổi trực tiếp cho hàng hóa. 1.3 Sản phẩm bán trước: Đề cập đến các sản phẩm được phát hành bởi người bán bằng công cụ sản phẩm bán trước. Chỉ đánh dấu từ bán trước trên tiêu đề sản phẩm hoặc trang chi tiết sản phẩm và các sản phẩm không sử dụng công cụ bán trước sản phẩm không được phân loại là sản phẩm bán trước. hỗ trợ thương nhân bán hàng theo mô hình bán trước 1.5 Giá sản phẩm trước bán: là giá bán của sản phẩm trước bán. Giá của sản phẩm trước khi bán bao gồm hai phần: đặt cọc và thanh toán cuối cùng.',
    预售规则: 'Quy tắc bán trước',
    总金额: 'Tổng số tiền',
    投注金额必须大于0: 'Số tiền cược phải lớn hơn 0',
    请同意预售规则: 'Vui lòng đồng ý với quy tắc bán trước',
    投注小于最小限额: 'Số tiền cược nhỏ hơn giới hạn tối thiểu',
    投注大于最大限额: 'Số tiền cược lớn hơn giới hạn tối đa',
    当前期已封盘: 'Kỳ này đã đóng cửa',
    请选择投注内容: 'Vui lòng chọn nội dung cược',
    投注失败: 'Cược thất bại',
    投注成功: 'Cược thành công',
    红色: 'Màu đỏ',
    绿色: 'Màu xanh lá cây',
    紫色: 'Màu tím',
    购买金额: 'Số tiền mua',
    购买数量: 'Số lượng mua',
    税后金额: 'Số tiền sau thuế',
    税收: 'Thuế',
    结果: 'Kết quả',
    选择: 'Chọn',
    '输/赢': 'Thua/Thắng',
    创建时间: 'Thời gian tạo',
    'WIN GO彩票': 'WIN GO Lottery',
    'WIN GO规则详情':
        'Nếu bạn bỏ ra 100 để giao dịch, sau khi trừ 2 phí dịch vụ, giá trị hợp đồng của bạn là 98:<br/><br/>1. Chọn màu xanh: Nếu kết quả là 1,3,7,9 thì bạn sẽ được (98*2) 196;Nếu kết quả là 5 thì bạn sẽ được (98*1.5) 147<br/><br/>2. Chọn màu đỏ: Nếu kết quả là 2,4,6,8 thì được (98*2) 196;Nếu kết quả là 0 thì sẽ được (98*1.5) 147<br/><br/>3. Chọn màu tím: nếu kết quả là 0 hoặc 5 thì bạn sẽ nhận được (98*4.5) 441<br/><br/>4. Chọn số: Nếu kết quả trùng với số đã chọn, bạn sẽ nhận được (98*9) 882<br/><br/>5. Chọn lớn: Nếu kết quả hiện ra là 5,6,7,8,9 thì ta được (98*2) 196<br/><br/>6. Chọn nhỏ: Nếu kết quả hiện ra là 0,1,2,3,4 thì được (98*2) 196',
    该玩法不允许下注: 'Cách chơi này không cho phép cược',
    总赌注: 'Tổng cược',
    赔率: 'Tỷ lệ cược',
    选择3个唯一号码: 'Chọn 3 số duy nhất',
    '*如果开盘号码与3个投注号码匹配，则中奖。': '*Nếu số mở cửa khớp với 3 số cược, bạn sẽ thắng',
    '*如果开奖号码是相同号码中的任意三个，则中奖。': '*Nếu số trúng thưởng là bất kỳ ba số nào trong số giống nhau, bạn sẽ thắng',
    '*如果开盘号码与2个投注号码匹配，则中奖。（三个相同的数字除外）。': '*Nếu số mở cửa khớp với 2 số cược, bạn sẽ thắng (ngoại trừ ba số giống nhau)',
    选择2个相同的数字: 'Chọn 2 số giống nhau',
    选择一对独特的数字: 'Chọn một cặp số duy nhất',
    '选择至少1对相同号码和1对不同号码进行投注，如果开盘号码与投注号码相符，则中奖。': 'Chọn ít nhất 1 cặp số giống nhau và 1 cặp số khác nhau để cược, nếu số mở cửa khớp với số cược, bạn sẽ thắng',
    选择2个不同的数字: 'Chọn 2 số khác nhau',
    选择3个不同的数字: 'Chọn 3 số khác nhau',
    '*选择3个或更多不同的数字。所抽中的3个号码若不同且符合选择，则中奖': '*Chọn 3 hoặc nhiều số khác nhau. Nếu 3 số trúng thưởng khác nhau và khớp với lựa chọn, bạn sẽ thắng',
    '*选择2个或更多不同的号码。 如果抽取的2个号码不同且符合选择，则中奖。': '*Chọn 2 hoặc nhiều số khác nhau. Nếu 2 số trúng thưởng khác nhau và khớp với lựa chọn, bạn sẽ thắng',
    '*若开奖号码为三个连续号码，则中奖。': '*Nếu số trúng thưởng là ba số liên tiếp, bạn sẽ thắng',
    玩法提示1: 'Chọn 2 số giống nhau. Nếu kết quả rút thăm trùng với lựa chọn của bạn, bạn thắng (trừ khi 3 số giống nhau)',
    玩法提示2: 'Chọn 2 số giống nhau và 1 số khác nhau. Nếu kết quả rút thăm trùng với lựa chọn của bạn, bạn thắng.',
    玩法提示3: 'Chọn 3 số giống nhau. Nếu kết quả rút thăm trùng với lựa chọn của bạn, bạn thắng.',
    玩法提示4: 'Chọn 3 số giống nhau bất kỳ. Nếu kết quả rút thăm là 3 số giống nhau, bạn thắng.',
    玩法提示5: 'Chọn 3 số khác nhau trở lên. Nếu kết quả rút thăm trùng với lựa chọn của bạn, bạn thắng.',
    玩法提示6: 'Chọn 3 số liên tiếp bất kỳ. Nếu kết quả rút thăm là 3 số liên tiếp bất kỳ, bạn thắng.',
    玩法提示7: 'Chọn 2 số khác nhau trở lên. Nếu kết quả rút thăm là các số khác nhau và trùng với các số bạn đã chọn thì bạn thắng.',
    K3彩票: 'K3 xổ số',
    K3规则详情:
        'Rút nhanh 3 viên xúc xắc để lấy 3 số trong mỗi hiệp, các số xúc xắc gồm các số tự nhiên từ 111 đến 666 (không có 0), các số xúc xắc không phải lúc nào cũng liên tiếp, bạn có thể đoán toàn bộ xúc xắc hoặc một phần xúc xắc.<br/><br/>Giá trị tổng<br/>Đoán tổng giá trị số của 3 con xúc xắc<br/><br/>3 số bằng nhau<br/>Đặt cược vào 3 số đặc biệt giống nhau (111, 222, ..., 666).<br/><br/>2 số bằng nhau<br/>Đặt cược vào 2 số giống nhau<br/><br/>2 số giống nhau + 1 số khác nhau<br/>Đặt cược vào 2 số giống nhau và 1 số khác nhau<br/><br/>3 số khác nhau<br/>Đặt cược vào 3 số khác nhau<br/><br/>2 số khác nhau<br/>Đặt cược vào 2 số khác nhau<br/><br/>3 số liên tiếp<br/>Đặt cược vào 3 số liên tiếp<br/>(123, 234, 345, 456)<br/><br/>Nhỏ (3-11)<br/>Lớn (12-18)',
    总和: 'Tổng số',
    '奇/偶': 'Lẻ/Chẵn',
    '2个相同': '2 giống nhau',
    '3个相同': '3 giống nhau',
    '3个连续': '3 liên tiếp',
    不同数字: 'Khác nhau',
    '5D彩票': '5D xổ số',
    '5D规则详情':
        'Hướng dẫn vẽ<br/>Số có 5 chữ số (00000-99999) sẽ được rút ngẫu nhiên trong mỗi kỳ<br/>Ví dụ:<br/>Số rút thăm trong Kỳ này là 12345<br/>A=1<br/>B=2<br/>C=3<br/>D=4<br/>E=5<br/>TỔNG=A+B+C+D+E=15<br/>Cách chơi<br/>Người chơi có thể chỉ định sáu kết quả cá cược A, B, C, D, E và tổng số tiền<br/>A, B, C, D, E có thể mua được<br/>Số (0 1 2 3 4 5 6 7 8 9)<br/>Thấp (0 1 2 3 4)<br/>Lẻ (1 3 5 7 9)<br/>Cao (5 6 7 8 9)<br/>Lẻ (1 3 5 7 9)<br/>Chẵn (0 2 4 6 8)<br/>Tổng = A+B+C+D+E có thể mua được<br/>Thấp (0-22)<br/>Cao (23-45)<br/>Lẻ (1 3 ···43 45)<br/>Cặp (0 2 ···42 44)',
    下拉即可刷新: 'Kéo xuống để làm mới',
    释放即可刷新: 'Phát hành để làm mới',
    没有更多了: 'không còn nữa',
    试玩提示: 'Bạn đang tham gia trải nghiệm dùng thử; không thể rút tiền sau khi kiếm được lợi nhuận',
    分享链接: 'chia sẻ liên kết',
    应用已更新: 'Ứng dụng đã được cập nhật',
    点击确定重启App生效: 'Nhấp vào OK để khởi động lại ứng dụng',
    热门: 'Phổ biến',
    最近: 'Gần đây',
    收藏: 'Yêu thích',
    邀请好友帮忙提现: '1. Mời bạn bè giúp rút tiền',
    向随机玩家发送邀请以提供帮助: '2. Gửi lời mời đến người chơi ngẫu nhiên để giúp đỡ',
    通过短信发送消息: 'Gửi tin nhắn trên ',
    短信: 'SMS',
    今天剩余提款额度: 'Số tiền rút còn lại của ngày hôm nay',
    VIP每日限额: 'Giới hạn VIP hàng ngày',
    今天剩余提款次数: 'Số lần rút tiền còn lại ngày hôm nay',
    VIP每日提款次数: 'Thời gian rút tiền VIP hàng ngày',
    单笔最小提款: 'Rút tiền tối thiểu một lần',
    单笔最大提款: 'Rút tiền tối đa một lần',
    USDT地址: 'địa chỉ USDT',
    今天提款次数已用完: 'Số lần rút hôm nay đã hết',
    提现提示: 'Mẹo rút tiền',
    系统异常: 'Ngoại lệ hệ thống',
    '你好，我们有一份礼物送给你': 'Xin chào, chúng tôi có một món quà dành cho bạn',
    请输入礼品代码: 'Vui lòng nhập mã quà tặng',
    奖金金额: 'Số tiền thưởng: {value}',
    关注官方渠道获取代码: 'Theo dõi kênh chính thức để nhận mã',
    '该金额暂无可用的充值通道,请更换充值金额': 'Không có kênh nạp tiền nào cho số tiền này. Vui lòng thay đổi số tiền nạp.',
    联系客服: 'Liên hệ với dịch vụ khách hàng',
    上月: 'Tháng trước',
    礼物: 'Quà tặng',
    公链查询: 'Truy vấn chuỗi công khai',
    区块: 'Khối',
    区块时间: 'Thời gian khối',
    哈希: 'Băm',
    trx详情:
        'Giá trị băm là gì?<br/><br/>Bất kỳ ai biết những điều cơ bản về Bitcoin đều sẽ được tiếp xúc với một khái niệm, giá trị băm. Tiêu đề khối của Bitcoin có băm của khối trước đó, được sử dụng để trỏ đến khối trước đó.<br/><br/>Băm là phiên âm của băm tiếng Anh, chúng ta cũng có thể dịch nó thành băm, vì vậy giá trị băm cũng được gọi là giá trị băm. Giá trị băm là giá trị được tính toán bằng hàm băm (hoặc hàm băm/thuật toán băm). Để hiểu giá trị băm, người ta phải hiểu bản chất của hàm băm. Hàm băm có thể chuyển đổi tính toán một đầu vào có độ dài tùy ý thành đầu ra có độ dài cố định.<br/><br/>Mỗi hàm băm đều có thuộc tính là nếu giá trị đầu vào giống nhau, giá trị băm đầu ra cũng giống nhau. Nếu các giá trị đầu vào ​​​​​​​​​​​​​khác nhau, các băm đầu ra thường khác nhau, nhưng có rất ít khả năng xảy ra va chạm băm. Nếu va chạm băm bị loại trừ với một thay đổi nhỏ trong giá trị đầu vào, một giá trị băm hoàn toàn không liên quan sẽ được đưa ra. Vì hàm băm không thể đảo ngược và dễ xác minh nên gần như không thể đảo ngược giá trị đầu vào thông qua giá trị băm đầu ra. Nếu có giá trị đầu vào, giá trị băm tương ứng có thể được xác minh ngay lập tức.<br/><br/>Do đó, giá trị băm của mỗi khối là duy nhất, ngẫu nhiên, không thể phá vỡ, không thể làm giả, giá trị băm khối được tự động xác định và bản ghi không thể bị giả mạo.<br/><br/>Có bao nhiêu loại USDT?<br/><br/>1. Omni-USDT dựa trên mạng Bitcoin, địa chỉ gửi tiền là địa chỉ BTC và việc gửi tiền và rút tiền diễn ra thông qua mạng BTC;<br/><br/>2. ERC20-USDT dựa trên giao thức Ethereum ERC20, địa chỉ gửi tiền là địa chỉ ETH và việc gửi tiền và rút tiền diễn ra thông qua mạng ETH;<br/><br/>3. TRC20-USDT dựa trên giao thức TRON TRC20 và mạng TRX (TRON), địa chỉ gửi tiền là địa chỉ TRON và việc gửi tiền và rút tiền sẽ thông qua mạng TRON.<br/><br/>TrxHash là băm khối TRC20-USDT dựa trên giao thức TRON TRC20 và mạng TRX (TRON). Số cuối cùng được sử dụng làm kết quả của xổ số để xác định xem bạn có trúng xổ số hay không (nhấp vào Chiều cao khối để đến chuỗi công khai để truy vấn băm khối duy nhất)<br/><br/>Luật chơi như sau:<br/><br/>1. 1 lần rút thăm xổ số trong 1 phút, mua trong vòng 45 giây và không thể mua kết quả trong vòng 15 giây trước khi mở.<br/><br/>2. Mở khóa mua hàng cả ngày. Tổng số lần mua trong một ngày là 1440.<br/><br/>3. 3 điểm 1 lần, 5 điểm 1 lần, 10 điểm 1 lần, luật chơi giống như 1 điểm 1 lần, chỉ khác thời gian quay số là khác nhau.<br/><br/>4. Chữ số cuối cùng của Block hash được dùng làm kết quả xổ số:<br/><br/>Ví dụ:<br/><br/>Nếu giá trị băm là **b569, kết quả xổ số là 9<br/><br/>Giá trị băm **d14c, kết quả xổ số là 4<br/><br/>Nếu bạn chi 100 để giao dịch, sau khi trừ phí dịch vụ 2%, số tiền hợp đồng: 98<br/><br/>L Chọn màu xanh lá cây: nếu kết quả hiển thị 1,3,7,9, bạn sẽ nhận được (98 * 2) =196; nếu kết quả hiển thị 5, bạn sẽ nhận được (98 * 2) = 196<br/><br/>L Chọn màu đỏ: nếu kết quả hiển thị 2,4,6,8, bạn sẽ nhận được (98 * 2) =196; nếu kết quả hiển thị 0, bạn sẽ nhận được (98 * 2) = 196<br/><br/>l chọn màu tím: nếu kết quả hiển thị 0 hoặc 5, bạn sẽ nhận được (98 * 2) = 196<br/><br/>l Chọn số: Nếu kết quả mở giống với kết quả bạn đã chọn, bạn sẽ nhận được (98 * 9) = 882<br/><br/>l Chọn Lớn: nếu kết quả hiển thị 5,6,7,8,9, bạn sẽ nhận được (98 * 2) = 196<br/><br/>l Chọn Nhỏ: nếu kết quả hiển thị 0,1,2,3,4, bạn sẽ nhận được (98 * 2) = 196',
    'WIN TRX彩票': 'WIN TRX Lottery',
    确认进入游戏吗: 'Bạn có chắc chắn muốn vào trò chơi không?',
    奖励兑换码: 'Mã quà tặng',
    注册时间: 'Thời gian đăng ký',
    '7 天全额存款': '<span>{value}</span> ngày gửi tiền',
    何时可以领取奖金: 'Thời gian có thể rút tiền thưởng',
    神秘奖金: 'Giải thưởng bí ẩn',
    活动已过期: 'Hoạt động đã hết hạn',
    已领取: 'Đã nhận',
    首次存款: 'Gửi tiền lần đầu',
    活动说明: 'Giải thích hoạt động',
    等级优惠: 'Ưu đãi cấp độ',
    当前等级: 'Cấp độ hiện tại',
    铁: 'Sắt',
    青铜: 'Bạc',
    白银: 'Vàng',
    黄金: 'Bạch kim',
    铂金: 'Bạch kim',
    钻石: 'Kim cương',
    近7天游戏营业额: 'Doanh thu trò chơi gần đây {value} ngày',
    未达成: 'Chưa đạt',
    已申请: 'Đã được đăng ký',
    已收到: 'Đã nhận',
    保存: 'cứu',
    每周奖金: 'tiền thưởng hàng tuần',
    领取时间: 'Thời gian thu thập',
    加载更多: 'Tải thêm',
    游戏大厅: 'Sảnh trò chơi',
    更多游戏: 'Thêm trò chơi',
    底部描述:
        '{value} được điều hành bởi {value2}, công ty đăng ký số 142922, có địa chỉ đã đăng ký tại Zuikertuintjeweg Z/N (Tháp Zuikertuin) Curacao và được cấp phép và ủy quyền bởi Chính phủ Curacao. {value} hoạt động theo Giấy phép chính của Nhà cung cấp dịch vụ trò chơi, N.V. Số giấy phép: GLH-OCCHKTW065752688',
    底部描述2:
        ' <p>1. Sản phẩm này dành cho người dùng từ 18 tuổi trở lên và chỉ dùng cho mục đích giải trí.</p><p>2. Trò chơi này có chứa các giao dịch mua trong ứng dụng.</p><p>3. Việc người chơi chơi hoặc thắng trò chơi đánh bạc xã hội không có nghĩa là người đó sẽ thắng trò chơi đánh bạc bằng tiền thật và các trò chơi liên quan trong tương lai.</p>',
    版权声明: '{value} {value2}. Mọi quyền được bảo lưu. 18+',
    支付成功: 'Thanh toán thành công',
    最大掉落: '{value} 123 tại một thời điểm thả tối đa',
    每天几次: '{value} lần một ngày',
    当前输赢: 'Mất mát hiện tại',
    当前可领金额: 'Số tiền hiện có sẵn',
    上一期输赢: 'Số phát hành cuối cùng bị mất',
    上一期可领金额: 'Số tiền có sẵn cho kỳ trước',
    赎回基金表: 'Bảng quỹ hoàn trả',
    比赛失败: 'Trò chơi thất bại',
    赎回费用: 'phí đổi quà',
    救援金: 'quỹ cứu trợ',
    本周补偿: 'Bồi thường tuần này',
    本周盈利: 'Lợi nhuận tuần này',
    可获得补偿: 'Có sẵn bồi thường',
    本周的补偿将分配到: 'Tiền bồi thường của tuần này sẽ được phân phối cho',
    每周报酬: 'Bồi thường hàng tuần',
    补偿: 'Đền bù',
    累计投注: 'Cược tích lũy',
    通过累积投注提升VIP等级: 'Nâng cấp cấp độ VIP bằng cách tích lũy cược',
    立即下载: 'Tải ngay',
    下载应用程序: 'Tải ứng dụng',
    您要下载并安装APP吗: 'Bạn có muốn tải và cài đặt ứng dụng không?',
    暂无可用手机号: 'Hiện chưa có số điện thoại di động',
    '下载地址不存在，请稍后重试': 'Địa chỉ tải không tồn tại, vui lòng thử lại sau',
    '下载已开始，请在通知栏查看下载进度': 'Tải đã bắt đầu, vui lòng xem tiến độ tải trong thanh thông báo',
    '下载失败，请稍后重试': 'Tải không thành công, vui lòng thử lại sau',
    支付倒计时: 'Vui lòng hoàn thành thanh toán trong {value}',
    支付方式: 'Phương thức thanh toán',
    钱包支付: 'Thanh toán với ví',
    取消充值申请: 'Hủy yêu cầu nạp tiền',
    查看充值记录: 'Xem lịch sử nạp tiền',
    打开App: 'Mở ứng dụng {value}',
    每日游戏收入: 'Doanh thu trò chơi hàng ngày',
    签到奖金: 'Bồi thường đăng ký',
    手机号首位不能为0: 'Số điện thoại không thể bắt đầu bằng 0',
    真实姓名只能包含英文字母和空格: 'Tên thật chỉ có thể chứa chữ cái và khoảng trắng',
    请输入正确的银行卡账号: 'Vui lòng nhập số tài khoản ngân hàng hợp lệ',
    请输入15位仅包含数字和字母的账号: 'Vui lòng nhập số tài khoản 15 ký tự chỉ gồm chữ và số',
    请输入CLABE账号: 'Vui lòng nhập tài khoản CLABE',
    请输入正确的CLABE账号: 'Vui lòng nhập tài khoản CLABE hợp lệ',
    利息: 'Lãi suất',
    转入金额必须大于: 'Số tiền chuyển phải lớn hơn {value}',
    最小金额为: 'Tối thiểu {value}, chỉ số nguyên',
    已转入: 'Đã tải',
    年利率: 'Lãi suất hàng năm {value}%',
    周期: `<span><span style="color: var(--profit-color-hover);">{value}</span> Chu kỳ Giải quyết (Tối đa <span style="color: var(--profit-color-hover);"> {value2}</span>)</span>`,
    待处理: `<span> Đang chờ <span style="color: var(--profit-text-warning);"> {value} </span> (Hoàn thành {value2}) </span>`,
    收取: 'Nhận',
    累计收益: 'Doanh thu Tích lũy <span style="color: var(--profit-text-warning);"> {value}</span>',
    交易类型: 'Loại Giao dịch',
    奖金: 'Thưởng',
    详细资料: 'Hồ sơ Chi tiết',
    规则说明: 'Quy tắc Chăm sóc',
    解决周期: 'Chu kỳ Giải quyết',
    转账金额: 'Số tiền Chuyển',
    当前时间: 'Thời gian Hiện tại',
    存款利息结算: 'Sau khoản tiền gửi này, lãi đầu tiên sẽ xuất hiện vào {value}',
    确认转账: 'Xác nhận Chuyển khoản',
    当前储蓄本: 'Sổ Tiết kiệm Hiện tại',
    转出金额: 'Số tiền Đã Chuyển',
    本次循环的倒计时: 'Thời gian Đếm ngược cho Chu kỳ này',
    提取利息提示: 'Khi rút ra, bạn sẽ mất lãi của chu kỳ này!',
    确认提现: 'Xác nhận rút tiền',
    转入: 'Chuyển vào',
    账户余额: 'Số dư tài khoản',
    提款最小金额: 'Số tiền rút tối thiểu {value}',
    提取金额必须大于: 'Số tiền rút phải lớn hơn {value}',
    提取金额不能超过账户金额: 'Số tiền rút không thể vượt quá số dư tài khoản',
    提取成功: 'Rút tiền thành công',
    提取失败: 'Rút tiền thất bại',
    转入成功: 'Chuyển vào thành công',
    转入失败: 'Chuyển vào thất bại',
    无限: 'Không giới hạn',
    时: '{value} Giờ',
    分: '{value} Phút',
    秒: '{value} Giây',
    利息宝未开启: 'Lãi suất không được mở',
    已完成: 'Đã hoàn thành',
    处理中: 'Đang xử lý',
    已取消: 'Đã hủy',
    已提交: 'Đã gửi',
    审核中: 'Đang kiểm tra',
    出款中: 'Đang rút tiền',
    出款失败: 'Rút tiền thất bại',
    已审核: 'Đã kiểm tra',
    补单成功: 'Cập nhật rút tiền thành công',
    补单失败: 'Cập nhật rút tiền thất bại',
    请输入UTR: 'Vui lòng nhập UTR',
    请输入数字和字母: 'Vui lòng nhập số và chữ',
    补单: 'Cập nhật rút tiền',
    请输入12位数字: 'Vui lòng nhập 12 số',
    最多只能选择9个号码: 'Chỉ có thể chọn tối đa 9 số',
    请选择支付方式: 'Vui lòng chọn phương thức thanh toán',
    用户ID: 'ID người dùng/Số điện thoại',
    总余额: 'Tổng số dư',
    提现余额: 'Số dư có thể rút',
    请输入用户ID: 'Vui lòng nhập ID người dùng/Số điện thoại',
    TelegramChannel: 'Kênh Telegram',
    真实姓名的长度不小于5个字符: 'Tên thật phải có ít nhất 5 ký tự',
    下载: 'Tải xuống',
    强度: 'Độ mạnh',
    余额不足: 'Số dư không đủ',
    客服: 'Hỗ trợ',
    有效投注总额: "Tổng cược hợp lệ",
    盈亏总额: "Tổng lãi và lỗ",
    注册账户: 'Đăng ký tài khoản',
    注册完成后可获得奖励: 'Sau khi hoàn thành đăng ký, bạn có thể <span class="intro-highlight">nhận được {value}</span> phần thưởng',
    
    // Đăng nhập bên thứ ba liên quan
    第三方登录: 'Đăng Nhập Bên Thứ Ba',
    登录方式: 'Đăng nhập bằng',
    
    // Liên quan đến tải trang callback
    '正在处理登录...': 'Đang xử lý đăng nhập...',
    '请稍候，即将为您跳转': 'Vui lòng đợi, đang chuyển hướng...',
    赠送中心: 'Trung tâm tặng quà',
    截止日期: 'Ngày kết thúc',
    返回顶部: 'Lên đầu trang',
    游戏: 'Trò chơi',
    搜索游戏: 'Tìm kiếm trò chơi',
    下注成功: 'Cược thành công',
    下注失败: 'Cược thất bại',
    游戏历史: 'Lịch sử trò chơi',
    期数: 'Chu kỳ',
    存款宝箱: 'Rương Kho Báu Nạp Tiền',
    归回累存: 'Tích lũy nạp tiền trở lại',
    统计截至: 'Thống kê đến',
    剩余天数: 'Số ngày còn lại',
    当前累计: 'Tổng tích lũy hiện tại',
    距: 'Còn',
    还差: 'Còn thiếu',
    当前可领取: 'Hiện có thể nhận',
    档: 'Bậc',
    累计门槛: 'Ngưỡng tích lũy',
    赠送金额: 'Số tiền thưởng',
    打码: 'Yêu cầu cược',
    可提前领取: 'Có thể nhận sớm. Sau khi nhận, không thể đạt bậc cao hơn',
    活动进行中: 'Sự kiện đang diễn ra',
    活动到期领取: 'Sự kiện đang diễn ra. Có thể nhận thưởng sau khi sự kiện kết thúc',
    第几天: 'Ngày {value}',
    已于第几天领取: 'Đã nhận <strong>{value1}</strong> vào ngày {value}',
    几天: '{value} ngày',
    回归每日首存: 'Lần nạp đầu ngày của người chơi trở lại',
    今日时间: 'Thời gian hôm nay',
    今日首笔存款: 'Khoản nạp đầu tiên hôm nay',
    可用奖金: 'Tiền thưởng khả dụng',
    奖金比例: 'Tỷ lệ thưởng',
    立即领取: 'Nhận ngay',
    去充值: 'Nạp tiền',
    查看活动: 'Xem sự kiện',
    再充值一点更划算: 'Nạp thêm một chút để nhận thưởng tốt hơn',
    当前档: 'Bậc hiện tại',
    冲刺档: 'Bậc mục tiêu',
    冲: 'Nạp thêm',
    直接领取当前奖励: 'Nhận ngay {value}',
    活动结束: 'Sự kiện đã kết thúc',
    恭喜领取成功: 'Nhận thưởng thành công',
    累计奖励已入账户: 'Thưởng tích lũy {value} đã được cộng vào tài khoản',
    请完成打码流水后提现: 'Vui lòng hoàn thành yêu cầu cược trước khi rút tiền',
    知道了: 'Đã hiểu',
    去下注: 'Đặt cược',
    充值后最高赠送: 'Thưởng tối đa sau khi nạp: {value}',
    倍数: 'Hệ số',
    必须通过此页面充值才能获得多倍奖金: 'Bạn phải nạp tiền qua trang này để nhận thưởng nhân',
    已领取宝箱金额: 'Đã nhận thưởng rương',
    已领取翻倍奖励: 'Đã nhận thưởng gấp {value} lần',
    充值领取最高: 'Nạp tiền để nhận tối đa {multiple} lần, thưởng {value}',
    说明: 'Hướng dẫn',
    翻倍充值说明: 'Hướng dẫn nạp tiền nhân thưởng',
    参与活动: 'Tham gia sự kiện',
    领取额外奖励: 'Nhận thêm phần thưởng',
    开始时间: 'Thời gian bắt đầu',
    流水倍数: 'Hệ số cược',
    打开: 'Mở',
    继续领取: 'Tiếp tục nhận',
    翻倍领取: 'Nhận thưởng nhân',
};
